// Module
var code = "<div class=\"block-12__text\"> <p class=\"block-12__text__text sofia light p10 uppercase\"></p> </div> <template id=\"block-12__image-template\"> <div class=\"block-12__image image\"></div> </template> ";
// Exports
export default code;